import React from "react";
const MenuChucNang = ({ }) => (
    <div className="search-new"  style={{marginTop:"-30px"}}>
        <div className="input-sm-new" style={{ display: "flex", flexDirection: "column", gap: "20px", width: "100%"}}>
            <ul className="nav nav-tabs tabMorman mt-1" style={{ borderRadius: "10px", border: "none" }}>
                <li className="nav-item">
                    <a className="nav-link active" id="base-tab1" data-toggle="tab" aria-controls="tab1" href="#hang-san-xuat" aria-expanded="true" style={{maxHeight:"35px"}}>
                        <h4>Hãng Sản Xuất</h4>
                    </a>
                </li>
                <li className="nav-item">
                    <a className="nav-link" id="base-tab2" data-toggle="tab" aria-controls="tab2" href="#dong-san-pham" aria-expanded="false" style={{maxHeight:"35px"}}>
                        <h4>Dòng Sản Phẩm</h4>
                    </a>
                </li>

                <li className="nav-item">
                    <a className="nav-link" id="base-tab3" data-toggle="tab" aria-controls="tab3" href="#thuoc-tinh-giam-tru" aria-expanded="false" style={{maxHeight:"35px"}}>
                        <h4>Thuộc Tính Giảm Trừ</h4>
                    </a>
                </li>
            </ul>
        </div>
    </div>
);

export default MenuChucNang;